import { addNotification } from './notifikasi';

const TRANSACTION_STATUS_STORAGE_KEY = 'donatur_transaction_status_snapshots';

const PENDING_STATUSES = [
  'pending',
  'menunggu konfirmasi',
  'diproses',
  'processed',
  'processing',
];

const SUCCESS_STATUSES = ['success', 'verified', 'diverifikasi', 'berhasil', 'sukses'];
const REJECTED_STATUSES = ['rejected', 'reject', 'ditolak', 'di tolak', 'gagal', 'failed'];

export function normalizeTransactionStatus(status) {
  return String(status || 'pending').trim().toLowerCase();
}

export function isSuccessTransactionStatus(status) {
  return SUCCESS_STATUSES.includes(normalizeTransactionStatus(status));
}

export function isRejectedTransactionStatus(status) {
  return REJECTED_STATUSES.includes(normalizeTransactionStatus(status));
}

function isPendingTransactionStatus(status) {
  return PENDING_STATUSES.includes(normalizeTransactionStatus(status));
}

function getTransactionStatus(trx) {
  return normalizeTransactionStatus(trx?.status || trx?.status_transaksi || trx?.statusTransaksi || 'pending');
}

function getTransactionIdentity(trx) {
  return String(
    trx?.id ||
    trx?.id_transaksi ||
    trx?.kode_transaksi ||
    trx?.kode_detail_transaksi ||
    ''
  ).trim();
}

function getSnapshotStorageKey(kodeDonatur) {
  return `${TRANSACTION_STATUS_STORAGE_KEY}:${kodeDonatur}`;
}

function readTransactionStatusSnapshot(kodeDonatur) {
  if (!kodeDonatur) return {};

  try {
    const raw = localStorage.getItem(getSnapshotStorageKey(kodeDonatur));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeTransactionStatusSnapshot(kodeDonatur, snapshot) {
  if (!kodeDonatur) return;

  try {
    localStorage.setItem(getSnapshotStorageKey(kodeDonatur), JSON.stringify(snapshot));
  } catch {
    // Keep the page usable if localStorage is blocked.
  }
}

export function normalizeTransactionList(payload) {
  if (Array.isArray(payload?.transaksi)) return payload.transaksi;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

export function syncTransactionStatusNotifications(kodeDonatur, transaksiList) {
  if (!kodeDonatur || !Array.isArray(transaksiList) || !transaksiList.length) return;

  const previousSnapshot = readTransactionStatusSnapshot(kodeDonatur);
  const nextSnapshot = {};

  transaksiList.forEach((trx) => {
    const transactionKey = getTransactionIdentity(trx);
    if (!transactionKey) return;

    const currentStatus = getTransactionStatus(trx);
    const previousStatus = previousSnapshot[transactionKey];
    nextSnapshot[transactionKey] = currentStatus;

    if (previousStatus === currentStatus) return;
    if (previousStatus && !isPendingTransactionStatus(previousStatus)) return;

    const kodeTransaksi = trx?.kode_transaksi || transactionKey;

    if (isSuccessTransactionStatus(currentStatus)) {
      addNotification({
        title: 'Transaksi Berhasil',
        message: `Transaksi ${kodeTransaksi} sudah berhasil dikonfirmasi admin.`,
        userType: 'donatur',
        audienceKey: kodeDonatur,
      });
    }

    if (isRejectedTransactionStatus(currentStatus)) {
      addNotification({
        title: 'Transaksi Ditolak',
        message: `Transaksi ${kodeTransaksi} ditolak oleh admin. Silakan periksa kembali data pembayaran Anda.`,
        userType: 'donatur',
        audienceKey: kodeDonatur,
      });
    }
  });

  writeTransactionStatusSnapshot(kodeDonatur, nextSnapshot);
}
